import {
  FETCH_PRACTICELIST_REQUEST,
  FETCH_PRACTICELIST_SUCCESS,
  FETCH_PRACTICELIST_FAILURE,
} from "./practicecompListTypes";

const initialState = {
  loading: false,
  practiceList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRACTICELIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PRACTICELIST_SUCCESS:
      return {
        loading: false,
        practiceList: action.payload,
        error: "",
      };
    case FETCH_PRACTICELIST_FAILURE:
      return {
        loading: false,
        practiceList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
